<template>
<div :class="videoFlag ? 'main-page' : 'main-page main-pages'" id="main-parent" ref="mainpage">
    <div class="top-title">
        <div class="top-title-left">
          <img src="../assets/img/guangbo.png" alt="">
          <p>福利通知:</p>
        </div>
        <div style="width:200px">
          <marquee behavior="scroll" width="500" loop="-1" scrollamount="4">{{inform || '【限时福利】即日起***时间，转发视频并集赞，就有机会成为飞鹤品鉴之星，赢千元大奖，赶快上车哦~' }}</marquee>
        </div>
    </div>
   <div :class="videoFlag ? 'header' : 'header headers'">

     <div :class="videoFlag ? 'video-box' : 'video-box video-boxs'">
        <video-player v-on:DOMFLAG="DOMFLAG" :isOpenShare="isOpenShare || deleteonoff"></video-player>
      </div>
   </div>
    <div v-if="videoFlag" :class="firstFlag ? 'comment-list comment-lists' : 'comment-list'" id="main" ref="commentlistrefs">
        <!-- likes集赞量  number参与人数 coverimg显示头像 -->
        <div class="tab-top">
          <div class="tab-left">
              <img :src="item" alt="" v-for="(item,index) in coverimg" :key="index">
              <span  v-show="numberPeople > 0">{{numberPeople}}人参与</span>
          </div>
          <div class="tab-right" v-if="acquisitionTime !== 3">
            <img :src="condition !== 0 ? require('../assets/img/bangdan.png') : require('../assets/img/canyu.png')" @click="determine">
          </div>
          <div class="tab-right" v-else>
            <img :src="require('../assets/img/bangdan.png')" @click="determine">
          </div>
        </div>
        <!-- 讨论切换 -->
        <div class="tab-all">
            <div class="tab-item" @click="tabchange(1)" :class="{'tab-active': publicParams.currentTab == 1}">
                <div class="tab-item-text">
                  <!-- <img :src="publicParams.currentTab == 1 ? require('../assets/img/alltaolun.png') : require('../assets/img/allactive.png')" alt=""> -->
                  全部讨论
                  <!-- <span>({{tranNumber(totalObj.allComments || 0, 1)}})</span> -->
                  <span class="tab-textNum">{{tranNumber(totalObj.allComments || 0, 1)}}</span>
                </div>
                <i></i>
            </div>
            <div class="tab-item" @click="tabchange(2)" :class="{'tab-active': publicParams.currentTab == 2}">
                <div class="tab-item-text">
                  <!-- <img :src="publicParams.currentTab == 2 ? require('../assets/img/myactive.png') : require('../assets/img/mytaolun.png')" alt=""> -->
                  我的讨论
                  <span class="tab-textNum">{{tranNumber(commentList.length || 0, 1)}}</span>
                </div>
                <i></i>
            </div>
            <p class="tab-item-zan">集星{{tranNumber(likes || 0, 1)}}</p>
        </div>
        <!--   -->
        <div class="list" v-show="list.length > 0 || commentList.length > 0">
          <div class="redheart" v-show="isHeart">
            <img src="../assets/img/redheart.gif" alt="">
          </div>
            <md-scroll-view ref="scrollView" :scrolling-x="false" :auto-reflow="true" @refreshing="$_onRefresh" @end-reached="$_onEndReached">
                <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"></md-scroll-view-refresh>
                <div class="my-comment-list" v-if="publicParams.currentTab == 2 && commentList.length >= 0">
                    <!-- <p class="title">我的讨论（{{commentList.length}}）</p> -->

                    <ul class="my-list" >
                        <template v-for="item in commentList">
                            <li class="item" :key="item.id">
                                <div class="item-title">
                                    <div class="item-time">
                                      <div class="username-con">
                                          <img :src="item.coverImg || require('../assets/img/default-coverimg.png')" alt />
                                          <span class="username">{{ item.nickName || "用户" + item.openId.substring(item.openId.length-6)}}</span>
                                      </div>
                                    </div>
                                    <div>
                                        {{TimeDifference(item.createTime,currentdate)}}
                                        <div v-if="item.isCheck != 1" class="delete-btn" @click="deleteMessage(item.id)">删除</div>
                                    </div>
                                </div>
                                <p class="comment-content"><span class="sift-comment" v-if="item.isSift == 1">精品</span>{{item.commentContent}}</p>
                                <p class="check-tips">
                                    <span v-if="item.isCheck == 0">您的故事已提交，1个工作日内会完成审核，请耐心等待！</span>
                                    <span class="isCheck-success" v-else-if="item.isCheck == 1">
                                        <span class="sift" v-if="item.isSift == 1">恭喜您，您与我们的故事已入选精品讨论！</span>
                                        <!-- <span v-else>审核通过，会有更多人了解您与我们的故事！</span> -->
                                    </span>
                                    <span class="isCheck-faild" v-else-if="item.isCheck == 2">您的故事未通过审核，请删除！</span>
                                </p>
                            </li>
                        </template>
                    </ul>

                    <!-- <p class="show-morelist" v-if="commentList.length > 1" @click="openmycomment()">
                        {{openmycommentonoff ? '收起' : '我的更多讨论'}}
                        <i :class="{'up' : openmycommentonoff}"></i>
                    </p> -->
                </div>
                <ul class="all-comment-list" v-if="list.length > 0 && publicParams.currentTab == 1">
                    <template v-for="item in list">
                        <li :key="item.id" class="all-comment-item">
                            <div class="name">
                                <div class="username-con">
                                    <img :src="item.coverImg || require('../assets/img/default-coverimg.png')" alt />
                                    <span class="username">{{ item.nickName || "用户" + item.openId.substring(item.openId.length-6)}}</span>
                                </div>
                                <!-- <span v-else>
                        用户{{item.openId.substring(item.openId.length-6)}}
                        <span class="sift-comment" v-if="item.isSift">精品</span>
                  </span>-->
                                <span class="item-time">{{TimeDifference(item.createTime,currentdate)}}</span>
                            </div>
                            <p class="comment-content"><span class="sift-comment" v-if="item.isSift">精品</span>{{item.commentContent}}</p>
                        </li>
                    </template>
                </ul>
                <md-scroll-view-more v-if="publicParams.currentTab == 1" class="md-scroll-more" slot="more" :is-finished="isFinished" finished-text="--已经是底线了哦--"></md-scroll-view-more>
                <md-scroll-view-more v-if="publicParams.currentTab == 2" class="md-scroll-more1" slot="more" :is-finished="isFinished" finished-text="---已经到底---"></md-scroll-view-more>
                <md-scroll-view-more v-if="publicParams.currentTab == 2" class="md-scroll-more2" slot="more" :is-finished="isFinished" finished-text="最多评论50条"></md-scroll-view-more>
            </md-scroll-view>
        </div>
        <div class="no-data-tip" v-if="hasGetData && list.length <= 0 && publicParams.currentTab == 1">
            <img src="../assets/img/no-data.png" alt="没数据" />
            <p v-show="publicParams.currentTab == 1">留下您的故事，让我们一起倾听您的经历。</p>
        </div>
        <div class="no-data-tip" v-if="hasGetData && commentList.length <= 0 && publicParams.currentTab == 2">
            <img src="../assets/img/no-data.png" alt="没数据" />
            <p v-show="publicParams.currentTab == 2">留下您的故事，分享您的心得。</p>
        </div>
    </div>
    <!--  -->
    <div class="footer" v-if="videoFlag && acquisitionTime == 1">
        <div class="footer">
        <div class="btns">
            <!-- 分享 -->
            <p class="share-btn" @click="onSharePage(true)">
                <span></span>
                <i>{{tranNumber(totalObj.share || 0, 1)}}</i>
            </p>
            <!-- 店在哪 -->
            <p class="fabulous-btn" :class="{'isCollect': totalObj.isCollect}" @click="mediaRecord()">
                <span></span>
                <i>{{tranNumber(totalObj.collect || 0, 1)}}</i>
            </p>
        </div>
        <!-- 激活输入框 -->
        <span class="showpopup-btn" id="comment-childs" @click="showPopUp('bottom')">留下您的故事...</span>

    </div>
    </div>

    <!-- <md-popup v-model="isPopupShow" class="comment-popup" position="bottom" @show="getfouce" @beforeHide="hidefn"> -->
        <!-- 输入框 -->
        <div class="comment-box" id="comment-child" v-if="isPopupShow">
            <div class="comment-container">
              <textarea name id class="comment-input" ref="commentInput" maxlength="300" @blur="hidefn" @focus="getfouce($event)" v-model="commentContent" placeholder="留下您的故事..." ></textarea>
              <span class="comment-len">{{commentContent.length >= 300 ? 0 : (300 - commentContent.length)}}</span>
            </div>
            <!-- <md-textarea-item class="comment-input" ref="commentInput" max-length="300" @blur="hidefn" @focus="getfouce" v-model="commentContent" placeholder="记录您与我们的故事..."></md-textarea-item> -->
            <!-- <mt-field  class="comment-input" ref="commentInput" max-length="300" @blur="hidefn" @focus="getfouce"  placeholder="记录您与我们的故事..." type="textarea" rows="4" v-modal="commentContent"></mt-field> -->
            <div class="comment-footer">
                <p id="comment-btn" class="comment-btn" :class="{'disabled': !commentContent.trim()}" @click="commentContent.trim() ? insertMessage() : ''">发送</p>
            </div>
        </div>
    <!-- </md-popup> -->

    <hover-button v-if="videoFlag && acquisitionTime !== 3" v-on:isPhoneShow="isPhoneShow" :acquisitionTime="acquisitionTime" :condition="condition"></hover-button>

    <share-page ref="sharePage" @closeSharePage="onSharePage" v-show="isOpenShare"></share-page>

    <!-- 注册弹窗 -->
    <md-popup class="md-popups" v-model="isPopupPhoneShow" :mask-closable="false">
        <div class="register-box">
            <div class="register-info">

                <md-input-item ref="input0" title="" placeholder="姓名" type="text" v-model.trim="registerinfo.name" :maxlength="10" class="register-item">
                    <span class="name-icon" slot="left"></span>
                </md-input-item>

                <p class="register-item register-item-native">
                    <span class="phone-icon"></span>
                    <input type="tel" v-model="registerinfo.phone"  @input="registerinfo.phone = registerinfo.phone.replace(/[^\d]/g,'')" placeholder="手机号" maxlength="11" @focus="inpFocus()" @blur="inpBlur(1)" />
                </p>

                <p class="register-item register-item-native">
                    <span class="verification-icon"></span>
                    <input type="tel" v-model="registerinfo.verification" @input="registerinfo.verification = registerinfo.verification.replace(/[^\d]/g,'')" placeholder="验证码" maxlength="6" @focus="inpFocus()" @blur="inpBlur()" />
                    <span class="getverification-btn" :class="{'disabled-btn' : !registerinfo.phone}" v-if="countdown == 60" @click.stop="getverification">获取验证码</span>
                    <span class="getverification-btn disabled-btn" v-else>{{countdown}}s</span>
                </p>
                <div id="captcha"></div>

                <div class="infor_agreement">
                    <img v-if="!isChecked" @click="isChecked = true" src="../assets/img/rankingimg/no-checked.png" alt="">
                    <img v-else @click="isChecked = false" src="../assets/img/rankingimg/checked.png" alt="">
                    <span class="infor_explain">注册即同意<a @click="goregisterAgreement">用户协议及隐私政策</a>，请仔细阅读说明</span>
                </div>
                <div class="confrim-btn-box">
                    <div class="confrim-btn" :class="{'disabled-confrim-btn': !registerinfo.name || !registerinfo.phone || !registerinfo.verification || !isChecked}">
                        <img @click.stop="confrimregister" src="../assets/img/rankingimg/register-confrim1.png" alt="">
                    </div>
                </div>
            </div>
            <div class="close-box">
                <img @click="closeboxBtn()" src="../assets/img/rankingimg/close-icon.png" alt="">
            </div>
        </div>
    </md-popup>
    <!-- 首次进入页面规则弹窗 -->
    <div class="msg" v-if="firstFlag && acquisitionTime !== 3 && acquisitionTime !== 4">
        <div class="msg-content">
            <index-Msg></index-Msg>
        </div>
        <img @click="closeMsg()" class="close-msg" src="../assets/img/rankingimg/close-icon.png" alt />
    </div>
    <!-- 新手引导 -->
    <div class="guide" v-show="guideFlag && acquisitionTime !== 3 && acquisitionTime !== 4">
        <img class="img-one" v-show="guideOne" @click="guideFn(1)" src="../assets/img/one.png" alt="">
        <img class="img-two" v-show="guideTwo" @click="guideFn(2)" src="../assets/img/two.png" alt="">
        <img class="img-three" v-show="guideThree" @click="guideFn(3)" src="../assets/img/three.png" alt="">
        <img class="img-four" v-show="guideFour" @click="guideFn(4)" src="../assets/img/four.png" alt="">
        <img class="img-five" v-show="guideFive" @click="guideFn(5)" src="../assets/img/five.png" alt="">
    </div>
    <!-- 活动未开始和活动结束弹窗 -->
    <div class="acquisition-msg" v-if="acquisitionTime != 1 && acquisitionFlag">
        <div class="acquisition-contant">
          <div class="acquisition-top">
            <img v-if="acquisitionTime == 4" src="../assets/img/hdnostart.png" alt="">
            <img v-else-if="acquisitionTime == 3" src="../assets/img/hdend.png" alt="">
          </div>
          <div class="acquisition-text">
            <p>活动时间:</p>
            <p>{{startTime}}~{{endTime}}</p>
          </div>
        </div>
        <div class="acquisition-close">
          <img @click="acquisitionFlag = false" src="../assets/img/rankingimg/close-icon.png" alt="">
        </div>
    </div>
</div>
</template>

<script>
import {
    ScrollView,
    ScrollViewRefresh,
    ScrollViewMore,
    TextareaItem,
    Popup,
    PopupTitleBar,
    InputItem,
    TabBar,
    Toast,
    Dialog,
    Button,
} from "mand-mobile";
import { Field } from 'mint-ui';
import {
    tranNumber,
    getCookie,
    getUrlParms
} from "@/assets/utils/common.js";
import {
    getJSSDK
} from "@/assets/utils/jssdk.js";
import sharePage from "@/components/sharePage/index.vue";
import videoPlayer from "@/components/videoPlayer.vue";
import hoverButton from "@/components/hoverButton.vue";
import indexMsg from "@/components/indexMsg.vue";

export default {
    name: "index",
    components: {
        [ScrollView.name]: ScrollView,
        [ScrollViewRefresh.name]: ScrollViewRefresh,
        [ScrollViewMore.name]: ScrollViewMore,
        [TextareaItem.name]: TextareaItem,
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
        [InputItem.name]: InputItem,
        [TabBar.name]: TabBar,
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        sharePage,
        videoPlayer,
        hoverButton,
        indexMsg,
        [Field.name]: Field,
    },
    data() {
        return {
            list: [], // 全部讨论列表|| 精品讨论列表
            commentList: [], // 我的讨论列表
            totalObj: {}, // 页面数量对象
            openmycommentonoff: false, // 展开我的讨论列表
            isFinished: false, // 是否加载完成
            scrollTop: 20,
            isRefreshActive: true,
            isRefreshing: true,
            isPopupShow: false, // 显示讨论输入框
            commentContent: "", // 输入的讨论
            isOpenShare: false, // 是否点击分享按钮
            publicParams: {
                // 公共参数
                currentTab: 1,
                current: 1,
                size: 20,
            },
            openId: "", // oc63ewnchTVlZ2p57XOwchZrcmks
            hasGetData: false, // 是否获取过数据
            clickCount: 0,
            deleteonoff: false,
            firstFlag: false, //是否第一次进入页面
            domHeight: "",//页面高度
            guideFlag: false,//新手引导显示
            guideOne: true,
            guideTwo: false,
            guideThree: false,
            guideFour: false,
            guideFive: false,
            videoFlag: true,
            //注册弹窗
            uncommitted: false, //是否参与排行榜
            isPopupPhoneShow: false, // 弹窗开关
            registerinfo: {
                phone: '',
                verification: '',
                name: '',
            },
            countdown: 60, // 倒计时60s
            isChecked: false,
            pclickCount: 0,
            condition: 0, //判断是否参与活动了

            coverimg: "",
            likes: "",
            numberPeople: "",

            acquisitionFlag: false,
            acquisitionTime: "", //活动是否开始结束
            startTime: "",//活动开始时间
            endTime: "",//活动结束时间
            inform: "",//福利通知
            isHeart: false,//红心
            successCode: false,//验证码是否获取成功
            currentdate: "",//当前时间
            leftTime:[],
            rightTime:[],
        };
    },
    async created() {
        // 关闭ios的橡皮筋效果
        // this.donotslide()
        console.log(getCookie("openId"));
        this.$set(this, "openId", getCookie("openId"));
        sessionStorage.setItem('moveAdjustmentFlag',0)
        // gio("init", "ac853984fcde2e20", {});
        // location.href.indexOf("active.feihe.com") >= 0 ? gio("init", "8a280edd3fe6d7e0", {}) : gio("init", "ac853984fcde2e20", {})
        // gio('config', {'hashtag':true});
        // gio("send");
        this.saveTypeRecord();

        if (!sessionStorage.getItem("urlIndex")) {
            this.getfirstLanding();
        } else {}
        // window.addEventListener("orientationchange", () => {
        //   // alert(window.orientation)
        //   if(window.orientation == 0) {
        //     if(this.$refs.mainpage.scrollTop > 0){
        //       this.$refs.mainpage.scrollTo(0, 0, false)
        //       alert("commentlistrefs" + this.$refs.commentlistrefs.clientHeight)
        //     }
        //   }
        // }, false);
        // let = client = Date.now();
        // console.log(let = client)
        // let = img = baseURL.baseURL + "/imgCode"
        // console.log(baseURL.baseURL)
        // this.codeGET();
        // var _self = this;

        // document.onkeydown = function(e) {
          // var key = window.event.keyCode;

          // if (key === 13) {
            console.log(111);
            // _self.searchEnterFun();
          // }
        // };
        // this.set_ALY_config().then(res => {
          // this.get_ALY_file()
        // })
        // 保证先在window下存在变量NVC_Opt再去加载js文件
        this.set_ALY_config()
    },
    mounted() {
        window.ScrollViewTrigger1 = () => {
            this.$refs.scrollView.triggerRefresh();
        };
        console.log(sessionStorage.getItem("urlIndex"), "sessionStorage.getItem");
        getJSSDK(location.href.replace("#/", ""), () => {
            this.$set(this, "isOpenShare", false);
        });
        this.getList();
        this.getmycomments();
        this.findEssentialMessage();
        this.set_ALY_config();
        this.acquisItion();
        //判断是首次进入页面还是在当前页面刷新操作
        if (window.performance.navigation.type == 1) {
          sessionStorage.setItem("urlIndex",1)
        }else{
          sessionStorage.setItem("urlIndex",0)
        }
        //textarea滚动问题
        window.addEventListener('touchmove',function(e){
          let target = e.target
          if(target && target.tagName === 'TEXTAREA'){
            e.stopPropagation();
          }else {
            e.preventDefault();
          }
        },true)
        //查看用户协议回退页面 保留注册弹窗
        if(JSON.parse(sessionStorage.getItem('isPopupPhoneShow'))) {
          this.registerinfo = JSON.parse(sessionStorage.getItem('registerinfo'))
          this.isChecked = JSON.parse(sessionStorage.getItem('isChecked'))
          this.isPopupPhoneShow = true
        }else {
          this.isPopupPhoneShow = false
        }
    },
    watch: {
      commentList:function (value,oldValue) {
        if(value.length >= 50) {
          this.isPopupShow = false
          this.$set(this, "isPopupShow", false);
        }
      }
    },
    methods: {
        tranNumber,
        DOMFLAG(DOMFLAG) {
          this.videoFlag = DOMFLAG;
        },
        currentFn() {
          var date = new Date();
          var seperator1 = "-";
          var seperator2 = ":";
          var month = date.getMonth() + 1<10? "0"+(date.getMonth()         + 1):date.getMonth() + 1;
          var strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
          var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
          + " "  + date.getHours()  + seperator2  + date.getMinutes()
          + seperator2 + date.getSeconds();
          this.currentdate = currentdate;
        },
        //活动是否开始结束
        acquisItion() {
          // activeStatus /1:在时间范围内,2:不在时间范围内
          this.$axios
                .get("/fission-video/fissionVideo/acquisitionTime")
                .then((res) => {
                  console.log(res,'resss')
                  // this.acquisitionTime = res.obj.activeStatus;//范围
                  this.startTime = res.obj.startTime;
                  this.endTime = res.obj.endTime;
                  this.inform = res.obj.inform;

                  var tmp = Date.parse( new Date() ).toString();
                      tmp = tmp.substr(0,10);
                  this.currentFn();
                  console.log(this.currentdate,'currentdate')
                  // res.obj.activeStatus == 2
                  console.log(tmp > res.obj.end,'活动已结束')
                  console.log(tmp < res.obj.begin,'活动为开始')
                  console.log(tmp > res.obj.begin && tmp < res.obj.end,'活动范围内')
                  if(res.obj.activeStatus == 2) {
                    this.acquisitionFlag = true
                     if(tmp > res.obj.end) {
                      this.acquisitionTime = 3
                      console.log('活动已结束')
                    }
                    else if(tmp < res.obj.begin) {
                      this.acquisitionTime = 4
                      console.log('活动未开始')
                    } else {
                      this.acquisitionTime = 2
                      console.log('活动范围内')
                    }

                  }else {
                    this.acquisitionTime = 1
                    this.acquisitionFlag = false
                  }

                })
                .catch((error) => {
                });
        },
        //确定参与和查看榜单
        determine() {
          // 0未参与  除0以外都是参与
            if(this.condition !== 0 || this.acquisitionTime == 3 ) {
                this.$router.push({
                    path: "/rankingList"
                });
                sessionStorage.setItem('isPopupPhoneShow',false)
            }else {
                this.isPopupPhoneShow = true;
            }
        },
        //禁止ios页面滚动
        moveAdjustment() {
            document.documentElement.ontouchmove=function(e){
              //根据存储的状态 看是否需要滚动
              if(sessionStorage.getItem('moveAdjustmentFlag') == 0){
                e.preventDefault();
              }else{
                e.returnValue = true
              }
            };
        },
        // 获取数据
        getList() {
            let params = {
                searchParams: {
                    // EQ$OPEN_ID: "oc63ewnchTVlZ2p57XOwchZrcmks",   // 查询自己的列表
                    EQ$DR: 0, // 非删除状态
                    EQ$IS_CHECK: 1,
                    EQ$IS_SIFT: this.publicParams.currentTab == 2 ? 1 : "",
                },
            };
            console.log(this.publicParams.current,'this.publicParams.current')
            if (this.publicParams.current <= 1) {
                this.list = [];
                this.hasGetData = false;
                // Toast.loading("加载中...");
            }
            params = Object.assign(params, this.publicParams);
            this.$axios
                .post("/fission-video/fissionVideo/findMessage", params)
                .then((res) => {
                    // Toast.hide()
                    if (res.status === "0") {
                        if (res.obj.current == 1) {
                            this.list = res.obj.records || [];
                            this.$refs.scrollView && this.$refs.scrollView.finishRefresh();
                        } else {
                            this.list = this.list.concat(res.obj.records || []);
                            this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
                        }
                        this.hasGetData = true;
                        console.log(this.list,'this.lisssssssssssssst')
                        if (this.list.length == res.obj.total) {
                            this.isFinished = true;
                        }
                    }
                })
                .catch((error) => {
                    // Toast.hide()
                    console.log(error);
                    this.hasGetData = true;
                    Toast({
                        content: (error && error.toString()) || "获取列表失败",
                        duration: 2000,
                        hasMask: true,
                    });
                });
        },
        // 查询是否是第一次进入页面
        getfirstLanding() {
            let params = {
                openId: this.openId,
            };
            this.$axios
                .post("/fission-video/fissionVideo/firstLanding", params)
                .then((res) => {
                    if (res.obj.state == 1) {
                        this.firstFlag = true;
                    } else {
                        this.firstFlag = false;
                    }
                });
        },
        //关闭奖励规则弹窗
        closeMsg() {
            this.firstFlag = false;
            this.guideFlag = true;
        },
        //新手引导
        guideFn(type) {
            switch (type) {
                case 1:
                    this.guideOne = false
                    this.guideTwo = true
                break;
                case 2:
                    this.guideTwo = false
                    this.guideThree = true
                break;
                case 3:
                    this.guideThree = false
                    this.guideFour = true
                break;
                case 4:
                    this.guideFour = false
                    this.guideFive = true
                break;
                case 5:
                    this.guideFive = false
                    this.guideFlag = false
                break;
                default:
                break;
            }
        },
        // 查询我的讨论列表
        getmycomments() {
            let params = {
                current: 1,
                size: 50,
                searchParams: {
                    EQ$OPEN_ID: this.openId, // 查询自己的列表
                    EQ$DR: 0, // 非删除状态
                },
            };
            this.$axios
                .post("/fission-video/fissionVideo/findMessage", params)
                .then((res) => {
                    if (res.status === "0") {
                        this.currentFn();
                        this.commentList = res.obj.records || [];
                        this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
                        this.hasGetData = true;
                    }
                })
                .catch((error) => {
                    Toast({
                        content: error.toString() || "获取我的讨论列表失败",
                        duration: 2000,
                        hasMask: true,
                    });
                });
        },
        // 视频裂变添查询/分享/收藏/全部讨论数量/精品数量
        findEssentialMessage() {
          //1参与了  0未参与 condition状态
            this.$axios
                .post("/fission-video/fissionVideo/findEssentialMessage", {})
                .then((res) => {
                    //获取用户参与没参与的状态
                    this.condition = res.obj.condition;
                    //coverimg 显示前三头像   likes集赞量 numberPeople参与人数
                    this.coverimg = res.obj.coverImg;
                    this.likes = res.obj.likes;
                    this.numberPeople = res.obj.numberPeople
                    if (res.status === "0") {
                        let data = res.obj || {};
                        for (let key in data) {
                            this.$set(this.totalObj, key, data[key]);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    Toast({
                        content: (error && error.toString()) || "获取数量失败",
                        duration: 1500,
                        hasMask: true,
                    });
                });
        },
        //判断当前点击是否在输入框范围内
        clickRange() {
            let _this = this
            if(document.getElementById('main-parent')){
              document.getElementById('main-parent').onclick=function(e){
                      var e = e || window.event;
                      var elem = e.target;
                      var targetArea = document.getElementById('comment-child');
                      var targetAreas = document.getElementById('comment-childs');
                      if(targetArea.contains(elem) || targetAreas.contains(elem)){
                          _this.$set(_this, "isPopupShow", true);
                      }else{
                          window.scrollTo(0, 0);
                          // _this.$refs.commentInput.blur();
                          _this.$set(_this, "isPopupShow", false);
                      }
              }
            }
        },
        // 保存手机机型
        async saveTypeRecord() {
            let aboutMobile = await this.getDevicetype();
            let params = Object.assign({
                    activeType: "1384a9e9f0e04443a803881ff01cf929",
                },
                aboutMobile
            );
            this.$axios
                .post("/active/activePhoneTypeRecord/saveTypeRecord", params)
                .then((res) => {})
                .catch((error) => {});
        },
        tabchange(currentTab) {
            this.$refs.scrollView && this.$refs.scrollView.scrollTo(0, 0, false);
            this.publicParams.current = 1;
            this.isFinished = false;
            this.openmycommentonoff = false;
            this.$set(this.publicParams, "currentTab", currentTab);
            this.getList();
            // if (this.publicParams.currentTab == 2) {
                this.getmycomments();
            // }
            this.findEssentialMessage();
        },
        // 添加留言接口
        insertMessage() {
            this.clickCount++;
            if (this.clickCount > 1) {
                return false;
            }
            let params = {
                commentContent: this.commentContent,
                shareOpenId: getUrlParms("openId"),
            };
            this.$axios
                .post("/fission-video/fissionVideo/insertMessage", params)
                .then((res) => {
                    console.log(res,'添加讨论');
                    if (res.status == 0) {
                        Toast({
                            content: res.msg.toString() || "添加讨论成功",
                            duration: 2000,
                            hasMask: true,
                        });
                        this.commentContent = "";
                        this.$set(this, "isPopupShow", false);
                        this.clickCount = 0;
                        this.$refs.scrollView && this.$refs.scrollView.scrollTo(0, 0, false);
                        this.publicParams.current = 1;
                        this.publicParams.currentTab = 2;//tab切换我的讨论
                        setTimeout(this.getList, 500);
                        setTimeout(this.getmycomments, 500);
                        this.getList();
                        this.getmycomments();
                        this.findEssentialMessage();
                    }
                    // if (res.status == '-1') {
                    //     Toast({
                    //         content: res.msg.toString() || "添加讨论失败",
                    //         duration: 2000,
                    //         hasMask: true,
                    //     });
                    //     this.commentContent = "";
                    //     this.$set(this, "isPopupShow", false);
                    //     this.clickCount = 0;
                    //     this.publicParams.current = 1;
                    //     setTimeout(this.getList, 500);
                    //     setTimeout(this.getmycomments, 500);
                    //     this.getmycomments();
                    //     this.findEssentialMessage();
                    // }
                    // if(res)
                })
                .catch((error) => {
                    console.log(error);
                    this.clickCount = 0;
                    Toast({
                        content: error.toString() || "添加讨论失败",
                        duration: 2000,
                        hasMask: true,
                    });
                });
        },
        //计算评论时间大于或小于一分钟
        TimeDifference(oldTime,newTime) {
          console.log(this.list,'this.listlistlistlist')
          console.log(this.commentList,'this.commentListcommentListcommentList')
            // console.log(oldTime,newTime,'ssssssssssssssssssssss')
              //定义两个变量time1,time2分别保存开始和结束时间
              var time1 = oldTime;
              var time2 = newTime;
              // var time1 = '2020-10-27 14:24:10';
              // var time2 = '2020-10-27 14:24:30';
              //判断开始时间是否大于结束日期
              // if(time1>time2)
              // {
              //   alert("开始时间不能大于结束时间！");
              //   return false;
              // }

              //截取字符串，得到日期部分"2009-12-02",用split把字符串分隔成数组
              var begin1=time1.substr(0,10).split("-");
              var end1=time2.substr(0,10).split("-");
              //将拆分的数组重新组合，并实例成化新的日期对象
              var date1=new Date(begin1[0] + '-' + begin1[1] + '-' + begin1[2]);
              var date2=new Date(end1[0] + - + end1[1] + - + end1[2]);
              var date3=date1.valueOf(date1);
              var date4=date1.valueOf(date2);
              //得到两个日期之间的差值m，以分钟为单位
              //Math.abs(date2-date1)计算出以毫秒为单位的差值
              //Math.abs(date2-date1)/1000得到以秒为单位的差值
              //Math.abs(date2-date1)/1000/60得到以分钟为单位的差值
              var m=parseInt(Math.abs(date4-date3)/1000/60);
              //小时数和分钟数相加得到总的分钟数
              //time1.substr(11,2)截取字符串得到时间的小时数
              //parseInt(time1.substr(11,2))*60把小时数转化成为分钟
              var min1=parseInt(time1.substr(11,2))*60+parseInt(time1.substr(14,2));
              var min2=parseInt(time2.substr(11,2))*60+parseInt(time2.substr(14,2));

              //两个分钟数相减得到时间部分的差值，以分钟为单位
              var n=min2-min1;
              //将日期和时间两个部分计算出来的差值相加，即得到两个时间相减后的分钟数
              var minutes=n/60;
              if (minutes == 0 || minutes == 1) {
                return '刚刚'
              }else {
                return time1.trim().split(" ")[0]
              }
        },
        //删除讨论
        deleteMessage(id) {
            this.$set(this, "deleteonoff", true);
            Dialog.confirm({
                title: "确认删除",
                content: "删除后您的讨论将不再显示？",
                confirmText: "删除",
                onConfirm: () => {
                    let params = {
                        messageId: id,
                    };
                    this.$axios
                        .post("/fission-video/fissionVideo/deleteMessage", params)
                        .then((res) => {
                            if (res.status == 0) {
                                this.$set(this, "deleteonoff", false);
                                Toast({
                                    content: res.msg.toString() || "删除讨论成功",
                                    duration: 2000,
                                    hasMask: true,
                                });
                                this.publicParams.current = 1;
                                setTimeout(this.getmycomments, 500);
                            }
                            // if(res)
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$set(this, "deleteonoff", false);
                            Toast({
                                content: error.toString() || "删除讨论失败",
                                duration: 2000,
                                hasMask: true,
                            });
                        });
                },
                onCancel: () => {
                    this.$set(this, "deleteonoff", false);
                },
            });
        },
        //点赞
        mediaRecord() {
            if(this.condition !== 0){
              //参与活动
              this.clickCount++;
              console.log(this.clickCount, this.clickCount > 1);
              if (this.clickCount > 1) {
                  return false;
              }
              let params = {
                  type: this.totalObj.isCollect == "1" ? "10002" : "10001",
                  shareOpenId: getUrlParms("openId"),
              };
              this.$axios
                .post("/fission-video/fissionVideo/mediaRecord", params)
                .then((res) => {
                    if (res.status == 0) {
                        // Toast({
                        //   content: res.msg.toString() || "点赞成功",
                        //   duration: 2000,
                        //   hasMask: true,
                        // })
                        this.isHeart = true;
                        setTimeout(() => {
                            this.isHeart = false;
                        }, 2200);
                        setTimeout(() => {
                            this.clickCount = 0;
                        }, 500);
                        this.findEssentialMessage();
                    }
                    // if(res)
                })
                .catch((error) => {
                    console.log(error);
                    this.clickCount = 0;
                    Toast({
                        content: error.toString() || "点赞失败",
                        duration: 2000,
                        hasMask: true,
                    });
                });
            }else{
              //没参与活动
              this.isPopupPhoneShow = true;

            }

        },
        // 下拉刷新
        $_onRefresh() {
            console.log("_onRefresh");
            this.openmycommentonoff = false;
            this.publicParams.current = 1;
            this.isFinished = false;
            this.getList();
            this.getmycomments();
            this.findEssentialMessage();
        },
        // 上拉加载
        $_onEndReached() {
            if (this.isFinished) {
                return;
            }
            this.publicParams.current++;
            this.getList();
        },
        async showPopUp(type) {
            if(this.condition !== 0 ){
              this.getmycomments()
              if (this.commentList.length >= 50) {
                  return Toast({
                      content: "每人限留言50条，您已达上限！",
                      duration: 1500,
                      hasMask: true,
                  });
                  this.isPopupShow = false;
              }else{
                // 显示输入框，自动获取焦点
                this.$set(this, "isPopupShow", true);
                if ((await this.getDevicetype().type.indexOf("iPhone")) != -1) {
                    this.$nextTick(() => {
                        this.$refs.commentInput.focus();
                        this.setTimeoutFn();
                    });
                }else{
                  this.$nextTick(() => {
                        this.$refs.commentInput.focus();
                    });
                }
              }
            }else{
              //没参与
              this.isPopupPhoneShow = true;
            }
        },
        setTimeoutFn() {
            var u = navigator.userAgent;
            var app = navigator.appVersion;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            let _this = this;
            if (isiOS) {
                setTimeout(() => {
                    if(document.body.clientHeight == localStorage.getItem("bodyheight") ) {
                        _this.domHeight = localStorage.getItem("bodyheight")
                    }else{
                        _this.domHeight = document.body.clientHeight
                    }
                        document.getElementById("app").style.height = _this.domHeight - window.scrollY + "px";
                        // 文档从顶部开始滚动过的像素值
                    _this.moveAdjustment()
                }, 300);
            }
        },
        // 弹出层里输入框获取焦点
        getfouce(e) {
            if (this.commentList.length >= 50) {
              console.log(this.commentList.length,'超过50条2')
                return Toast({
                    content: "每人限留言50条，您已达上限！",
                    duration: 1500,
                    hasMask: true,
                });
                this.$set(this, "isPopupShow", false);
            }else{
              //重新打开输入框时 光标在最后
              let obj = e.srcElement;
             	obj.focus();
              const len = obj.value.length;
              //光标定位要加上 setTimeOut，不然就会重新光标定位失败
              setTimeout(()=>{
                obj.selectionStart = obj.selectionEnd = len;
             	},60)
              console.log(this.commentList.length,'小于50条2')
              this.$set(this, "isPopupShow", true);
              this.$nextTick(() => {
                this.$refs.commentInput.focus();
                this.setTimeoutFn()
              });
            }
        },
        hidefn() {
            document.body.addEventListener('focusin', () =>{
              console.log('键盘弹起')
            })
            document.body.addEventListener('focusout', (e) =>{
              setTimeout(() => {
                window.scrollTo(0,0);
                this.$set(this, "isPopupShow", true);
              }, 100);
              console.log('键盘收回')
            })
            var u = navigator.userAgent;
            var app = navigator.appVersion;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            this.clickRange()
            if (isiOS) {
              if(document.body.clientHeight == localStorage.getItem("bodyheight") ) {
                  this.domHeight = localStorage.getItem("bodyheight")
              }else{
                  this.domHeight = document.body.clientHeight
              }
                document.getElementById("app").style.height = this.domHeight + "px";
                this.moveAdjustment()
            }
        },
        openmycomment() {
            this.openmycommentonoff = !this.openmycommentonoff;
            setTimeout(() => {
                this.$refs.scrollView.reflowScroller();
            }, 300);
        },
        // 获取当前机型
        getDevicetype() {
            //判断数组中是否包含某字符串
            Array.prototype.contains = function (needle) {
                for (i in this) {
                    if (this[i].indexOf(needle) > 0) return i;
                }
                return -1;
            };
            var device_type = navigator.userAgent; //获取userAgent信息
            console.log(device_type);
            var md = new MobileDetect(device_type); //初始化mobile-detect
            var os = md.os(); //获取系统
            var wxVersion = device_type.match(/MicroMessenger\/([\d\.]+)/i);
            var model = "";
            if (os == "iOS") {
                //ios系统的处理
                os = md.os() + md.version("iPhone");
                model = md.mobile();
            } else if (os == "AndroidOS") {
                os = md.os() + md.version("Android");
                var sss = device_type.split(";");
                var i = sss.contains("Build/");
                if (i > -1) {
                    model = sss[i].substring(0, sss[i].indexOf("Build/"));
                }
            }
            return {
                systemVersion: os, // 系统版本
                type: model, // 手机型号
                resolution: document.documentElement.clientWidth +
                    "*" +
                    document.documentElement.clientHeight, // 手机分辨率
                wxVersion: wxVersion[1], // 微信版本
            };
        },
        // 分享
        onSharePage(onoff) {
            this.$set(this, "isOpenShare", onoff);
            // this.player.destroy(isDelDom)
        },
        // 禁止ios的橡皮筋效果
        donotslide() {
            document.body.addEventListener(
                "touchmove",
                function (e) {
                    if (!e.isSCROLL) {
                        e.preventDefault(); //阻止默认事件(上下滑动)
                    } else {
                        //需要滑动的区域
                        var top = el.scrollTop; //对象最顶端和窗口最顶端之间的距离
                        var scrollH = el.scrollHeight; //含滚动内容的元素大小
                        var offsetH = el.offsetHeight; //网页可见区域高
                        var cScroll = top + offsetH; //当前滚动的距离

                        //被滑动到最上方和最下方的时候
                        if (top == 0) {
                            top = 1; //0～1之间的小数会被当成0
                        } else if (cScroll === scrollH) {
                            el.scrollTop = top - 0.1;
                        }
                    }
                }, {
                    passive: false,
                }
            ); //passive防止阻止默认事件不生效
        },
        //注册部分
        //注册弹窗关闭清空状态
        closeboxBtn() {
          if(this.successCode) {
            this.isPopupPhoneShow = false
            let timer = null;
            this.pclickCount = 0;
            console.log(this.countdown,'this.countdown')
            //倒计时num
            this.countdown--;
            timer = setInterval(() => {
              this.countdown--;
              if (this.countdown == 1) {
                  this.countdown = 60;
                  clearInterval(timer)
              }
            }, 1000)
            if(!this.isPopupPhoneShow){
              clearInterval(timer)
            }
            this.registerinfo = {
              phone: '',
              verification: '',
              name: '',
            }
            this.isChecked = false;
            this.successCode = false;
          }else {
            this.isPopupPhoneShow = false;
            this.pclickCount = 0;
            this.registerinfo = {
              phone: '',
              verification: '',
              name: '',
            }
            this.isChecked = false;
            this.successCode = false;
          }
        },
        inpFocus() {
            window.scroll(0, 0)
        },
        inpBlur(type) {
            if(type == 1) {
              this.pclickCount = 0;
            }
            window.scroll(0, 0)
        },
        //用户协议
        goregisterAgreement() {
            sessionStorage.setItem('registerinfo',JSON.stringify(this.registerinfo))
            sessionStorage.setItem('isChecked',this.isChecked)
            this.$router.push({
                path: '/registerAgreement'
            });
        },
        //滑块pk是否打开注册弹窗
        isPhoneShow(isPhoneShow) {
          this.isPopupPhoneShow = isPhoneShow
        },
        // 获取排行榜列表
        getlistPk() {
            this.$axios.post("/fission-video/fissionVideo/shareRanking", {}).then(res => {
                if (res.status === "0") {
                    // this.list = res.obj.ranking || [];
                    this.uncommitted = res.obj.currentUser;
                } else {
                    Toast({
                        content: (res && res.msg.toString()) || "获取列表失败",
                        duration: 2000,
                        hasMask: true
                    });
                }
            }).catch(error => {
                Toast({
                    content: (error && error.toString()) || "获取列表失败",
                    duration: 2000,
                    hasMask: true
                });
            });
        },
        //获取验证码
        getverification() {
            if (this.countdown < 60) {
                return;
            }
            let timer = null;
            if (!this.registerinfo.phone) {
                Toast({
                  content: "请输入手机号",
                  duration: 2000,
                  hasMask: true
                });
                return false;
            }

            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.registerinfo.phone)) {
                Toast({
                    content: "请输入正确的手机号",
                    duration: 2000,
                    hasMask: true
                });
                return false;
            }

            this.pclickCount++;
            if (this.pclickCount > 1) {
                return false;
            }
            this.traceLess()
            // this.$axios.post("/fission-video/fissionVideo/getVerification", {
            //     phone: this.registerinfo.phone
            // }).then(res => {

            // }).catch(error => {
            //     this.pclickCount = 0;
            //     Toast({
            //         content: (error && error.toString()) || "获取列表失败",
            //         duration: 2000,
            //         hasMask: true
            //     });
            // })

        },
        // 确认注册
        confrimregister() {
            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            var namereg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
            if (!this.registerinfo.name) {
                return false;
                // Toast({
                //   content: "请输入姓名",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (!namereg.test(this.registerinfo.name)) {
                Toast({
                    content: "姓名只允许输入中文、英文和数字",
                    duration: 2000,
                    hasMask: true
                });
                return false;

            }
            if (!this.registerinfo.phone) {
                return false;
                //  Toast({
                //   content: "请输入手机号",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (!myreg.test(this.registerinfo.phone)) {
                Toast({
                    content: "请输入正确的手机号",
                    duration: 2000,
                    hasMask: true
                });
                return false;
            }

            if (!this.registerinfo.verification) {
                return false;
                // Toast({
                //   content: "请输入验证码",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (this.registerinfo.verification.length != 6) { //验证码不正确
                return Toast({
                    content: "验证码错误",
                    duration: 2000,
                    hasMask: true
                });
            }

            if (!this.isChecked) {
                return false;
                // Toast({
                //   content: "请勾选用户协议及隐私政策",
                //   duration: 2000,
                //   hasMask: true
                // });
            }

            this.pclickCount++;
            if (this.pclickCount > 1) {
                return false;
            }

            this.$axios.post("/fission-video/fissionVideo/userRegistration", this.registerinfo).then(res => {
                console.log(res)
                this.pclickCount = 0;
                Toast({
                    content: res.msg.toString() || "注册成功",
                    duration: 2000,
                    hasMask: true
                });
                this.isPopupPhoneShow = false;
                this.getlistPk();
                this.findEssentialMessage();
                this.getList();
                this.getmycomments();
            }).catch(error => {
                this.pclickCount = 0;
                Toast({
                    content: (error && error.toString()) || "注册失败",
                    duration: 2000,
                    hasMask: true
                });
            })
        },
        //无痕校验
        set_ALY_config() {
          console.log('set_aly_config')
          var _this = this
          return new Promise((resolve, reject) => {
            window.NVC_Opt = {
                //无痕配置 && 滑动验证、刮刮卡验证通用配置。
                //应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                // appkey: getUrl() == 'https://active.feihe.com/pasture-tour' ? 'FFFF0N1N000000009320' : 'CF_APP_1',
                // // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
                // scene: getUrl() == 'https://active.feihe.com/pasture-tour' ? 'nvc_message_h5' : 'nvc_register_h5',
                appkey:'CF_APP_1',
                //使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
                scene:'nvc_register_h5',
                trans: {"key1": "code0","nvcCode":400},
                // appkey:'CF_APP_1',
                // //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
                // scene:'nvc_register_h5',
                //是否HTML5页面。对于HTML5页面类型，该参数值需填写true。
                isH5:true,
                //二次验证的唤醒方式。true为浮层式，false为嵌入式。
                popUp:false,
                //声明二次验证需要渲染的目标元素ID。
                renderTo:'#captcha',
                //回调参数。
                nvcCallback:function(data){
                    let params ={
                      phone:_this.registerinfo.phone,
                      data:data
                    }

                    _this.yourRegisterRequest("/fission-video/fissionVideo/afsGetVerification", params)
                    // 其中，data为getNVCVal()函数的值，该函数为二次验证滑动或者刮刮卡通过后的回调函数。
                    // data与业务请求一同上传，由后端请求AnalyzeNvc接口并返回100或者900。
                },
                //业务键字段，可为空。该参数可用于上线前测试，请按照代码集成后测试部分中的方法配置该字段值。
                // trans: getUrl() == 'https://activeuat.feihe.com/pasture-tour'? {} : {"key1": "code0","nvcCode":400},
                //二次验证组件的语言，默认为cn（简体中文）。详细配置方法请参见自定义文案文档。
                language: "cn",
                //当唤醒滑动验证作为二次验证时，配置滑动验证组件的宽度。
                customWidth: 300,
                //当唤醒刮刮卡验证作为二次验证时，配置刮刮卡组件的宽度。
                width: 300,
                //当唤醒刮刮卡验证作为二次验证时，配置刮刮卡组件的高度。
                height: 50,
                //当唤醒刮刮卡验证作为二次验证时，配置需要刮出的两个elements的图片资源。
                elements: [
                    '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
                    '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'
                ],
                //当唤醒刮刮卡验证作为二次验证时，配置刮动时的背景图像（自动应用平铺填充的方式）。
                bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
                //当唤醒刮刮卡验证作为二次验证时，配置刮动时的前景图像（仅支持base64数据流）。
                bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
                //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的图标资源。
                obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
                //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的背景图像（自动应用平铺填充的方式）。
                bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
                //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的图标资源。
                obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
                //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的背景图像（自动应用平铺填充的方式）。
                bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
                //当唤醒刮刮卡验证作为二次验证时，用于自定义文案。详细配置方法请参见自定义文案文档。
                upLang:{"cn":{
                    _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
                    _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
                    _ggk_loading: "加载中",
                    _ggk_fail: ['呀，盾牌不见了<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
                    _ggk_action_timeout: ['我等得太久啦<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
                    _ggk_net_err: ['网络实在不给力<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
                    _ggk_too_fast: ['您刮得太快啦<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题']
                    }
                }
            }
            resolve()
          })
      },
      yourRegisterRequest(url, params) {
        this.$axios.get("/fission-video/fissionVideo/afsGetVerification", {
                params
            }).then(res => {
                if(res.status ==-20) {
                    if(res.obj==400 || res.obj== 600 || res.obj==800  || res.obj==900){
                    //您注册请求的业务回调。
                    // geterroMsg("滑块验证通过后，发送短信验证码")
                    //唤醒滑动验证
                    getNC().then(function(){
                        NoCaptcha.upLang('cn', {
                            'LOADING':"加载中...",//加载
                            'SLIDER_LABEL': "请滑动，才能发送验证码",//等待滑动
                            'CHECK_Y':"验证通过",//通过
                            'ERROR_TITLE':"非常抱歉，这出错了..."//拦截
                        });
                        _nvc_nc.reset()
                    })}
                  }else if(res.status == 0){
                     //倒计时
                    let timer = null;
                    this.pclickCount = 0;
                    this.successCode = true;
                        Toast({
                            content: "验证码发送成功",
                            duration: 2000,
                            hasMask: true
                        });
                        //倒计时num
                        this.countdown--;

                        timer = setInterval(() => {
                            this.countdown--;
                            if (this.countdown == 1) {
                                this.countdown = 60;
                                clearInterval(timer)
                            }
                        }, 1000)
                  }
                  // else if(res.status ==-1){
                  //   //发送验证码失败
                  //       Toast({
                  //           content: res.msg,
                  //           duration: 2000,
                  //           hasMask: true
                  //       });
                  // }
            }).catch(error =>{
                Toast({
                  content: error.msg,
                  duration: 2000,
                  hasMask: true
                });
            })
      },
      // 动态加载js文件
      get_ALY_file() {
        try {
          console.log('加载js')
          var script = document.createElement('script');
          script.setAttribute('type', 'text/javascript');
          script.setAttribute('src', 'https://g.alicdn.com/sd/nvc/1.1.112/guide.js');
          document.documentElement.appendChild(script);
        } catch (e) {

        }
      },
      traceLess() {
        var params ={
          phone:this.registerinfo.phone,
          data:getNVCVal()
        }
        // "phone="+this.registerinfo.phone+"&data="+getNVCVal();
        this.yourRegisterRequest("/fission-video/fissionVideo/afsGetVerification", params)
      },
    },
};
</script>

<style lang="less">
.header,.footer {
    position:absolute;
    left:0;
    right:0;
    // height:50px;
}
.top-title {
  width: 100%;
  height: 50px;
  background: #FB870B;
  display: flex;
  align-items: center;
  z-index: 999;
  color: #fff;
  font-size: 23px;
  .top-title-left {
    display: flex;
    align-items: center;
    img {
      width: 22px;
      height: 22px;
      margin:0 15px
    }
  }
}
marquee {
    display: flex;
    align-items: center;
}
.headers {
    top:0;
}
.headers {
    width: 100%;
    top:-4%;
}
.footer {
    bottom:0
}
.main {
    position:absolute;
    left:0;
    top:464px;
    right:0;
    overflow-y:auto;
    -webkit-overflow-scrolling:touch;
}
.main-page {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: url(../assets/img/bg.png) no-repeat left top;
    background-size: 100% 100%;
    .video-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: calc(100% - 36px);
        height: 414px;
        padding: 15px;
        margin: 20px auto;
        box-shadow: 0px 0px 9px 0px rgba(125, 192, 239, 0.57);
        border-radius: 22px;
        background: #fff;
    }
    .video-boxs {
       width: 100%;
       margin: 0 auto;
    }
    .comment-list {
        width: 100%;
        height: calc(100% - 454px - 40px);
        margin: 0 auto;
        border-top-left-radius: 22px;
        border-top-right-radius: 22px;
        background: #fff;
        // overflow: hidden;
        position:absolute;
        left:0;
        top:500px;
        right:0;
        z-index: 999;
        // bottom:50px;
        // overflow-y:auto;
        -webkit-overflow-scrolling:touch;
        .tab-top {
          width: 95%;
          height: 90px;
          margin: 15px auto 0;
          background: url("../assets/img/tabTop.png") center no-repeat;
          background-size: 100%;
          display: flex;
          justify-content: space-between;
          line-height: 105px;
          color: #fff;
          .tab-left {
              align-items: center;
              margin-left: 70px;

              img {
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                  margin-left: -15px;
                  margin-top: -8px;
              }
              span {
                margin-left: 22px;
                line-height: 115px;
              }
          }
          .tab-right {
            margin-right: 40px;
            img {
              width: 173px;
            }
          }
        }
        .tab-all {
            display: flex;
            // justify-content: space-between;
            // align-items: center;
            width: 100%;
            padding: 38px 100px 0 0;
            overflow: hidden;
            box-shadow: -3px 10px 13px -7px rgba(125, 191, 239, 0.28);
            -webkit-box-shadow: -3px 10px 13px -7px rgba(125, 191, 239, 0.28);
            -moz-box-shadow: -3px 10px 13px -7px rgba(125, 191, 239, 0.28);
            border-bottom-left-radius: 22px;
            border-bottom-right-radius: 22px;
            .tab-item-zan {
                position: absolute;
                right: 44px;
                font-size: 30px;
                height: 66px;
                line-height: 55px;
                color: #b5b5b5;
            }
            .tab-item {
                position: relative;
                height: 66px;
                font-size: 30px;
                font-weight: 400;
                color: #999a9a;
                // flex: 1;
                // width: 200px;
                margin-left: 40px;
                text-align: center;
                .tab-item-text {
                  display: flex;
                  align-items: center;
                  img {
                    width: 22px;
                    height: 28px;
                    margin-left: 20px;
                    margin-right: 11px;
                  }
                  span {
                    font-size: 26px;
                    margin-left: 11px;
                  }
                }
                i {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                    display: block;
                    width: 81px;
                    height: 6px;
                    border-radius: 3px;
                    // margin: 30px auto 0;
                }
            }
            .tab-active {
                color: #ff8500;
                font-weight: 500;
                span {
                  color: #B4B4B4;
                }
                i {
                    background-color: #ff8500;
                }
            }
        }

        .list {
            height: calc(100% - 103px);
            .redheart {
              position: absolute;
              top: 120px;
              left: 50%;
              transform: translate(-50%, 0);
              img {
                width: 80px;
                height: 80px;
              }
            }
            .md-scroll-view {
                overflow-y: scroll !important;
            }

            .md-scroll-view::-webkit-scrollbar {
                display: none;
            }
            .md-scroll-more {
              margin-bottom: 130px;
            }
            .md-scroll-more2 {
              margin-bottom: 80px;
            }
            .md-scroll-more1 {
              margin-bottom: -60px;
            }
            .my-comment-list {
                // width: calc(100% - 50px);
                padding: 30px 0 10px 31px;
                // margin: 0 auto 0;
                // box-shadow: 0px 0px 16px 0px rgba(125, 192, 239, 0.38);
                // border-radius: 12px;
                font-weight: 400;
                color: #333;

                .title {
                    font-size: 24px;
                    line-height: 1;
                }

                .my-list {
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    .item {
                        margin-top: 10px;
                        overflow: hidden;
                        border-bottom: 1px solid #e7e7e7;
                        z-index: 999;
                        .item-title,
                        .check-tips {
                            font-size: 22px;
                            line-height: 62px;
                            color: #ccc;
                        }

                        .item-title {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-top: 15px;

                            .item-time {
                                color: #ccc;
                                width: 35%;
                                .username-con {
                                    display: flex;
                                    align-items: center;
                                    // width: 100%;
                                    line-height: 48px;

                                    img {
                                        width: 48px;
                                        height: 48px;
                                        margin-right: 10px;
                                        border-radius: 50%;
                                    }
                                    .username {
                                        max-width: 50%;
                                        color: #666;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        // display: block;
                                        // float: left;
                                    }
                                }

                            }
                             div {
                                  .boutique {
                                      padding: 2px 15px 0;
                                      margin-left: 5px;
                                      height: 34px;
                                      font-size: 24px;
                                      color: #fff;
                                      font-weight: 400;
                                      line-height: 34px;
                                      background: linear-gradient(90deg,
                                              rgba(255, 139, 7, 1),
                                              rgba(255, 192, 51, 1));
                                      border-radius: 20px;
                                  }
                                }
                            .delete-btn {
                                display: inline-block;
                                padding: 0 20px;
                                color: #76a3ff;
                            }
                        }

                        .comment-content {
                            // position: relative;
                            background: #f7f7f7;
                            border-radius: 6px;
                            font-size: 26px;
                            font-weight: 400;
                            line-height: 38px;
                            padding: 26px 16px;
                            white-space: pre-wrap;
                            word-wrap: break-word;
                            .sift-comment {
                                padding: 2px 15px 0;
                                margin-left: 10px;
                                margin-right: 10px;
                                height: 34px;
                                font-size: 24px;
                                color: #fff;
                                font-weight: 400;
                                line-height: 34px;
                                background: linear-gradient(90deg,
                                        rgba(255, 139, 7, 1),
                                        rgba(255, 192, 51, 1));
                                border-radius: 20px;
                            }
                        }

                        .check-tips {
                            margin-top: 18px;
                            margin-bottom: 15px;
                            line-height: 34px;

                            .isCheck-success {
                                color: #1cbe55;
                            }

                            .isCheck-faild {
                                color: #ff6b6b;
                            }

                            .sift {
                                color: #eba600;
                            }
                        }

                    //     &:not(:first-child) {
                    //         height: 0;
                    //         max-height: 0;
                    //         transition: max-height 0.3s;
                    //     }
                    }
                }

                .open-all {
                    .item {
                        border-bottom: 1px solid #e7e7e7;

                        &:last-child {
                            border-bottom: none;
                        }

                        &:not(:first-child) {
                            height: auto !important;
                            max-height: 900px;
                            transition: max-height 0.3s;
                        }
                    }
                }

                .show-morelist {
                    position: relative;
                    width: 100%;
                    height: 75px;
                    line-height: 75px;
                    font-size: 24px;
                    text-align: center;
                    color: #76b6ff;

                    i {
                        display: inline-block;
                        width: 21px;
                        height: 12px;
                        margin-left: 14px;
                        background: url(../assets/img/arrow.png) no-repeat center center;
                        background-size: 100% 100%;
                    }

                    .up {
                        transform: rotate(180deg);
                    }
                }
            }

            .all-comment-list {
                padding: 30px 0 10px 31px;
                .all-comment-item {
                    padding: 26px 10px 24px 23px;
                    border-bottom: 1px solid #e7e7e7;

                    .name {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 25px;
                        font-size: 24px;
                        font-weight: 400;
                        line-height: 1;
                        color: #666;

                        .username-con {
                            display: flex;
                            align-items: center;
                            width: 50%;
                            line-height: 48px;

                            img {
                                width: 48px;
                                height: 48px;
                                margin-right: 10px;
                                border-radius: 50%;
                            }
                        }

                        .username {
                            max-width: 50%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            // display: block;
                            // float: left;
                        }

                        .sift-comment {
                            padding: 2px 15px 0;
                            margin-left: 10px;
                            margin-right: 10px;
                            height: 34px;
                            font-size: 24px;
                            color: #fff;
                            font-weight: 400;
                            line-height: 34px;
                            background: linear-gradient(90deg,
                                    rgba(255, 139, 7, 1),
                                    rgba(255, 192, 51, 1));
                            border-radius: 20px;
                        }

                        .item-time {
                            color: #ccc;
                        }
                    }

                    .comment-content {
                        font-size: 26px;
                        color: #333;
                        font-weight: 400;
                        line-height: 36px;
                        white-space: pre-wrap;
                        word-wrap: break-word;
                        .sift-comment {
                            padding: 2px 15px 0;
                            margin-left: 10px;
                            margin-right: 10px;
                            height: 34px;
                            font-size: 24px;
                            color: #fff;
                            font-weight: 400;
                            line-height: 34px;
                            background: linear-gradient(90deg,
                                    rgba(255, 139, 7, 1),
                                    rgba(255, 192, 51, 1));
                            border-radius: 20px;
                        }
                    }
                }
            }
        }

        .no-data-tip {
            width: 100%;
            height: calc(100% - 103px);
            background: #ffff;
            position: absolute;
            top: 210px;
            z-index: 999;
            img {
                display: block;
                width: 170px;
                height: auto;
                margin: 30px auto 20px;
            }

            p {
                text-align: center;
                color: #333;
                font-size: 24px;
                font-weight: 400;
                line-height: 36px;
            }
        }
    }
    .comment-lists {
      overflow: hidden !important;
    }
    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 116px;
        padding: 0 24px;
        background: #fff;
        box-shadow: 0px -6px 13px 0px rgba(0, 0, 0, 0.06);

        .showpopup-btn {
            position: relative;
            display: block;
            width: 494px;
            height: 68px;
            margin-right: 12px;
            font-size: 24px;
            line-height: 68px;
            color: #ff8f09;
            background: #fff8e6;
            border-radius: 34px;
            text-indent: 68px;

            &::before {
                content: "";
                width: 20px;
                height: 20px;
                display: block;
                position: absolute;
                top: 25px;
                left: 32px;
                background: url(../assets/img/edit.png) no-repeat center top;
                background-size: 100% auto;
            }
        }

        .btns {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-around;
            padding: 6px 0;

            .fabulous-btn,
            .share-btn {
                width: 50%;

                span {
                    display: block;
                    width: 32px;
                    height: 35px;
                    margin: 0 auto;
                }

                i {
                    display: block;
                    font-size: 22px;
                    text-align: center;
                    line-height: 1;
                    color: #999;
                    font-weight: 400;
                    font-style: normal;
                }
            }

            .share-btn {
                span {
                    background: url(../assets/img/share-icon.png) no-repeat top center;
                    background-size: 29px auto;
                }
            }

            .fabulous-btn {
                span {
                    background: url(../assets/img/fabulous-icon.png) no-repeat top center;
                    background-size: 32px auto;
                }
            }

            .isCollect {
                span {
                    background: url(../assets/img/isCollect.png) no-repeat top center;
                    background-size: 32px auto;
                }
            }
        }
    }

    .edit-btn {}

    //注册弹窗
    .md-popups {
      z-index: 9999;
    }

    .register-box {
        width: 545px;
        height: auto;
        padding: 130px 0 65px;
        background: url(../assets/img/rankingimg/register-bg.png) no-repeat;
        background-size: 100% auto;
        z-index: 9999;
        .register-info {
            padding-bottom: 48px;

            .register-item {
                width: 460px;
                height: 69px;
                border: 1px solid #CBCBCB;
                border-radius: 36px;
                margin: 0 auto 30px;

                .name-icon {
                    width: 24px;
                    height: 32px;
                    background: url(../assets/img/rankingimg/my-name.png) no-repeat;
                    background-size: 100% auto;
                }

                .phone-icon {
                    display: inline-block;
                    width: 24px;
                    height: 29px;
                    margin-left: 32px;
                    background: url(../assets/img/rankingimg/phone.png) no-repeat;
                    background-size: 100% auto;
                }

                .verification-icon {
                    display: inline-block;
                    width: 20px;
                    height: 32px;
                    margin-left: 32px;
                    background: url(../assets/img/rankingimg/verification-icon.png) no-repeat;
                    background-size: 100% auto;

                }

                .getverification-btn {
                    width: 180px;
                    height: 69px;
                    margin-right: -1px;
                    color: #fff;
                    font-size: 24px;
                    line-height: 69px;
                    text-align: center;
                    background: #FF7D13;
                    border-radius: 36px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }

                .disabled-btn {
                    background: #C6C6C6;

                }

            }

            .register-item-native {
                display: flex;
                align-items: center;
                overflow: hidden;

                input {
                    flex: 1;
                    height: 100%;
                    padding: 0 14px;
                    font-size: 26px;
                    font-weight: 400;
                    color: #333;
                }

            }
            .confrim-btn-box{
                width: 100%;
                background: #fff;
                border-bottom-left-radius: 36px;
                border-bottom-right-radius: 36px;
            }
            .confrim-btn {
                width: calc(100% - 52px);
                // width: 100%;
                margin: 0 auto;
                border-radius: 36px;
                img {
                    width: 100%;
                    height: auto;
                }
            }

            .disabled-confrim-btn {
                filter: grayscale(100%);
            }

            .infor_agreement {
                display: flex;
                // align-items: inherit;
                width: 460px;
                margin: 0 auto;
                font-weight: 400;
                line-height: 34px;
                font-size: 20px;
                color: #BABABA;

                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 10px;
                    margin-top: 5px;
                }
            }
        }

        .close-box {
            width: 65px;
            padding-top: 82px;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    // 首次进入弹窗
    .msg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        display: flex;
        flex-direction: column;
    }

    .msg-content {
        width: 662px;
        height: 988px;
        background: url("../assets/img/jianglimsg.png") no-repeat center;
        background-size: 100%;
        margin: 98px auto;
        padding-bottom: 71px;
    }

    .close-msg {
        margin: -70px auto;
        width: 50px;
        height: 50px;
        z-index: 9999;
    }

    //首次进入新手引导
    .guide {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10001;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        img {
            width: 100%;
            height: 50%;
        }
        .img-one {
          position: absolute;
          top: 200px;
        }
        .img-two {
          position: absolute;
          bottom: 200px;
        }
        .img-three {
          position: absolute;
          top:100px;
        }
        .img-four {
          position: absolute;
          bottom: 200px;
        }
        .img-five {
          position: absolute;
          bottom: 200px;
        }
    }

    //活动未开始和活动结束
    .acquisition-msg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10001;
        background: rgba(0, 0, 0, 0.7);
        .acquisition-close {
          width: 67px;
          height: 67px;
          margin:-230px auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .acquisition-contant {
          width: 511px;
          height: 400px;
          background: url('../assets/img/hdmsg.png') center no-repeat;
          background-size: 100%;
          margin: 300px auto;
          padding-top: 117px;
          .acquisition-top {
            width: 415px;
            height: 141px;
            background: #F3F3F3;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            img {
              width: 234px;
              height: 44px;
            }
          }
          .acquisition-text {
            font-size: 24px;
            margin-left: 48px;
            margin-top: 33px;
            color: #B4B4B4;
          }
        }
    }
    .comment-popup {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index:9999;
    }

    .comment-box {
        width: 100%;
        height: 172px;
        padding: 30px 26px 0;
        border-radius: 20px;
        background: #fff;
        box-shadow: 0px -6px 24px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        bottom: 0;
        left: 0;
        z-index:9999;
        display: flex;
        .comment-container {
          width: 90%;
          height: 121px;
          background: #f7f7f7;
          border-radius: 13px;
          border: none;
          display: flex;
          flex-direction: column;
            span {
                display: inline-block;
                vertical-align: top;
                padding: 0 34px;
                height: 52px;
                font-size: 24px;
                line-height: 52px;
                font-weight: 400;
                text-align: right;
                // margin-top: 10px;
            }

            .comment-len {
                font-size: 22px;
                color: #acacac;
            }
            .comment-input {
                width: 100%;
                background: #f7f7f7;
                border-radius: 13px;
                border: none;
                overflow: auto;
                padding-top: 5px;
                font-size: 26px;
            }
        }


        .comment-footer {
            // width: 100%;
            height: 118px;
            // padding-top: 15px;
            // text-align: right;
            // font-size: 0px;
            margin-left: 10px;
            // span {
            //     display: inline-block;
            //     width: 100%;
            //     // vertical-align: top;
            //     padding: 0 34px;
            //     height: 118px;
            //     font-size: 24px;
            //     line-height: 52px;
            //     font-weight: 400;
            // }

            .comment-len {
                color: #acacac;
            }

            .comment-btn {
                width: 114px;
                height: 118px;
                color: #fff;
                background: linear-gradient(90deg, #ff8b07, #ffc033);
                border-radius: 18px;
                text-align: center;
                line-height: 118px;
            }

            .disabled {
                background: #ddd;
            }
        }
    }
}
.main-pages {
  background: #fff;
}

@media screen and (orientation: landscape) {
    //     .main-page{
    //         padding: 20px;
    //         overflow: auto;
    //         height: auto;
    //     }
    //     .main-page .video-box{
    //         margin: auto;
    //         width: 100%;
    //         height: 1000px;
    //         display: block;
    //     }
    //   .comment-list{
    //       display: none;
    //   }
    //   .footer{
    //       display: none !important;
    //   }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue